import { VoiceOrderItemDto } from './voice-order-item.dto';
import { OrderIntentEnum } from '../../enum/forecaster';

export class OrderResponseEventDto {
  intent: OrderIntentEnum;
  items?: VoiceOrderItemDto[];
  text?: string;
}